import type { ModuleDefinition } from '../types';

export const peopleModule: ModuleDefinition = {
  key: 'people',
  milestone: 'M5',
  network: { path: 'people', permission: 'person.read.network', labelKey: 'people' },
  tenant: { path: 'people', permission: 'person.read', labelKey: 'people' },
  load: () => import('./PeopleModule'),
};
